var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLayeredPeaksHaikei1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 900 600",
    width: 900,
    height: 600,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M565 600L627 514L590 429L540 343L587 257L614 171L551 86L630 0L900 0L900 86L900 171L900 257L900 343L900 429L900 514L900 600Z",
    fill: "#6a5acd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M617 600L677 514L695 429L652 343L709 257L708 171L607 86L713 0L900 0L900 86L900 171L900 257L900 343L900 429L900 514L900 600Z",
    fill: "#5f4ec2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M682 600L734 514L685 429L692 343L748 257L677 171L730 86L755 0L900 0L900 86L900 171L900 257L900 343L900 429L900 514L900 600Z",
    fill: "#5342b7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M730 600L796 514L739 429L797 343L783 257L801 171L789 86L801 0L900 0L900 86L900 171L900 257L900 343L900 429L900 514L900 600Z",
    fill: "#4737ac"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M858 600L835 514L823 429L797 343L834 257L816 171L810 86L835 0L900 0L900 86L900 171L900 257L900 343L900 429L900 514L900 600Z",
    fill: "#3b2ba2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayeredPeaksHaikei1);
export default __webpack_public_path__ + "static/media/layered-peaks-haikei (1).fc856ea7a50ddc8ce277252f1dd55968.svg";
export { ForwardRef as ReactComponent };